// TRUE RuneScape XP curve (2026-06-10). The old version divided the
// cumulative table by 26, which landed level 92 at ~1M XP — Skyler's
// complaint: "92 is half of 99 and 99 is like 13M". Vanilla RS divides
// by 4. Real thresholds this formula produces (matching the game):
//   Level   2 =         83 XP
//   Level  10 =      1,154 XP
//   Level  25 =      7,842 XP
//   Level  50 =    101,333 XP
//   Level  73 =    992,895 XP
//   Level  92 =  6,517,253 XP   (half of 99 — by design of the curve)
//   Level  99 = 13,034,431 XP
//   Level 126 ≈188,884,740 XP   (table caps here; XP_CAP gates at 200M).
// MUST stay in lockstep with public.level_for_xp in Postgres
// (migration 00069_xp_curve_true_runescape) — the DB derives the stored
// level inside award_xp; this table only drives display math.

const MAX_LEVEL = 126;
const XP_TABLE: number[] = [];

function buildXpTable() {
  if (XP_TABLE.length > 0) return;
  XP_TABLE[1] = 0;
  let total = 0;
  for (let l = 1; l < MAX_LEVEL; l++) {
    total += Math.floor(l + 300 * Math.pow(2, l / 7));
    XP_TABLE[l + 1] = Math.floor(total / 4);
  }
}

export function xpForLevel(level: number): number {
  buildXpTable();
  if (level <= 1) return 0;
  if (level > MAX_LEVEL) return XP_TABLE[MAX_LEVEL];
  return XP_TABLE[level];
}

export function levelForXp(xp: number): number {
  buildXpTable();
  for (let level = MAX_LEVEL; level >= 1; level--) {
    if (xp >= XP_TABLE[level]) return level;
  }
  return 1;
}

export function xpToNextLevel(xp: number): { current: number; next: number; progress: number } {
  const level = levelForXp(xp);
  if (level >= MAX_LEVEL) return { current: xp, next: xp, progress: 1 };
  const currentThreshold = xpForLevel(level);
  const nextThreshold = xpForLevel(level + 1);
  const progress = (xp - currentThreshold) / (nextThreshold - currentThreshold);
  return { current: xp - currentThreshold, next: nextThreshold - currentThreshold, progress };
}

export const XP_CAP = 200_000_000;

export function formatXp(xp: number): string {
  if (xp >= 1_000_000) return `${(xp / 1_000_000).toFixed(1)}M`;
  if (xp >= 1_000) return `${(xp / 1_000).toFixed(1)}K`;
  return String(xp);
}

export const XP_TIERS: Record<number, { label: string; xp: number }> = {
  1: { label: "Trivial", xp: 15 },
  2: { label: "Quick", xp: 30 },
  3: { label: "Standard", xp: 60 },
  4: { label: "Heavy", xp: 120 },
  5: { label: "Epic", xp: 250 },
};

export const PRIORITY_XP: Record<string, number> = {
  low: 15,
  medium: 30,
  high: 60,
};
